export default __webpack_public_path__ + "static/logo-fa713f34dc767ceb034a473b49a18bd5.png";